import { getActiveBuildings } from "./index24.js";
import { createRoofAndParapet, createRoofLevel } from "@project-rouge/rg-three";
const pipeAddRoofAndParapet = ([parent, { buildingIds, aggProps }]) => {
	const dataset = aggProps.dataset;
	const buildings = getActiveBuildings(parent, aggProps);
	for (const building of buildings) {
		if (buildingIds && !buildingIds.includes(building.uuid)) continue;
		createRoofAndParapet({
			building,
			roofLevels: createRoofLevel(building, dataset.id),
			parapetModId: dataset.modulousIds.parapetId,
			roofModId: dataset.modulousIds.roofId,
			facadeModId: dataset.modulousIds.facadeId,
			rvDataList: dataset.rvData
		});
	}
	return [parent, void 0];
};
export { pipeAddRoofAndParapet };

//# sourceMappingURL=index86.js.map